import { AlertTriangle, Send } from "lucide-react";

export const ConfirmSendModal = ({ open, count, templateName, onCancel, onConfirm }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] grid place-items-center bg-[#1A2E26]/50 backdrop-blur-sm p-4" data-testid="past-confirm-modal" onClick={onCancel}>
      <div role="dialog" aria-modal="true" className="w-full max-w-md rounded-3xl bg-white shadow-[0_30px_80px_rgba(26,46,38,0.35)] p-7" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-2xl bg-amber-50 text-amber-600"><AlertTriangle size={22} /></span>
          <h3 className="font-serif text-2xl leading-tight" data-testid="past-confirm-title">Please Confirm....</h3>
        </div>
        <div className="mt-5 space-y-1.5 text-sm text-foreground/90" data-testid="past-confirm-message">
          <p>You are sending bulk messages to past participant.</p>
          <p>Do you want to proceed?.</p>
        </div>
        <p className="mt-3 text-xs text-muted-foreground" data-testid="past-confirm-details">
          <span className="font-medium text-foreground">{count}</span> participant{count === 1 ? "" : "s"} · template <code className="bg-muted/60 rounded px-1">{templateName}</code> · WhatsApp only, no email
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" data-testid="past-confirm-cancel" onClick={onCancel} className="rounded-full border border-border px-5 py-2 text-sm hover:bg-muted transition-colors">No, cancel</button>
          <button type="button" data-testid="past-confirm-yes" onClick={onConfirm} className="inline-flex items-center gap-2 rounded-full bg-[#128C7E] text-white px-5 py-2 text-sm hover:bg-[#0f7568] transition-colors"><Send size={14} /> Yes, send now</button>
        </div>
      </div>
    </div>
  );
};
